// The Leagues canvas filter scope: League + Season, remembered per section (URL +
// localStorage, §7B decision 4). Season is constrained to the league — changing
// the league clears the season, and the filter bar then defaults it to that
// league's most recent (the FilterBar resolves that once /seasons loads).

import { useState } from "react";
import { readInitialScopeNumber, persistScopeNumber } from "../lib/scopeParams.js";

/** Default league = EPL (competition 2) — a sensible landing view for the demo. */
export const DEFAULT_COMPETITION_ID = 2;

const K_COMP = "leagues.competitionId";
const K_SEASON = "leagues.seasonId";

export interface LeaguesScope {
  competitionId: number | null;
  seasonId: number | null;
  setCompetitionId: (id: number) => void;
  setSeasonId: (id: number) => void;
}

export function useLeaguesScope(): LeaguesScope {
  const [competitionId, setComp] = useState<number | null>(
    () => readInitialScopeNumber(K_COMP) ?? DEFAULT_COMPETITION_ID
  );
  const [seasonId, setSeason] = useState<number | null>(() => readInitialScopeNumber(K_SEASON));

  const setCompetitionId = (id: number) => {
    setComp(id);
    persistScopeNumber(K_COMP, id);
    // A season only makes sense within a league — clear it so the FilterBar
    // re-defaults to the new league's latest (no stale cross-league season).
    setSeason(null);
    persistScopeNumber(K_SEASON, null);
  };

  const setSeasonId = (id: number) => {
    setSeason(id);
    persistScopeNumber(K_SEASON, id);
  };

  return { competitionId, seasonId, setCompetitionId, setSeasonId };
}
